let activeFacetDesk = document.querySelector(".active-facets.active-facets-desktop");
let collectionGrid = document.querySelector(".collection-list-main-wrapper");

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      console.log('input');
      if( $(window).width() > 749 ){
        this.onSubmitHandler(event);
      }else{
        if( $('menu-drawer facet-filters-form input:checked').length == 0 ){
          // $('body .mobile-facets__footer .apply-now').addClass('disabled');
          
          if($('body .mobile-facets__footer .apply-now').attr("data-disable") == 'true'){
            $('body .mobile-facets__footer .apply-now').addClass('disabled');
          }else{
            $('body .mobile-facets__footer .apply-now').removeClass('disabled');
          }
        }else{
          $('body .mobile-facets__footer .apply-now').removeClass('disabled');
        }
        if($('menu-drawer facet-filters-form input[type="number"]')){
          $('body .mobile-facets__footer .apply-now').removeClass('disabled');
        }
      }      
    }, 500);

    // if(window.outerWidth > 750){
      this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    // }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    // console.log("facetWrapper",facetWrapper); 
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.update_attr_url();
    //FacetFiltersForm.pageinfiniteScrolling();
  }  

  static setListeners() {
    const onHistoryChange = (event) => {      
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;      
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  
  static onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    //console.log('event',event,searchParams);
    var _customFilter = false;
    var _windowLocation = window.location.pathname;
    if( _windowLocation.match(/\//g).length > 2){
      _windowLocation = _windowLocation.split('/');
      _windowLocation = _windowLocation.filter((a) => a);    
      _windowLocation = `/${_windowLocation[0]}/${_windowLocation[1]}`;
    }    
    
    if( event != null ){
      // console.log('event.target.parentElement',event.target.parentElement,searchParams);      
      if( searchParams.indexOf('tag') != -1 ){
        _customFilter = true;        
        var _searchParamsTags = searchParams.split('&');
        // console.log(_searchParamsTags);        
        var _currentTag = [], _currentSP = [];
        for( var i = 0 ; i < _searchParamsTags.length ; i++  ){
          if( _searchParamsTags[i].indexOf('tag') > -1 ){
            _currentTag.push(_searchParamsTags[i].split('=')[1]);
          }else{
            _currentSP.push(_searchParamsTags[i]);
          }
        }
        searchParams = _currentSP.join('&');
        _currentTag = _currentTag.filter(FacetFiltersForm.onlyUnique);
      }
      if ( event != null && event.target.parentElement.getAttribute('data-custom-remove') == "true"){
        _windowLocation = event.target.parentElement.getAttribute('href')
      }
    }
    
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    //document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }


    
    sections.forEach((section) => {      
      const url = _customFilter ? `${_windowLocation}/${_currentTag.join('+')}?section_id=${section.section}&${_currentSP.join('&')}`:`${_windowLocation}?section_id=${section.section}&${searchParams}`;
      // console.log(url,'url');
      const filterDataUrl = element => element.url === url;
	  // console.log(_customFilter, url);
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    // console.log('_currentTag',_currentTag);
    if (updateURLHash){ if( _customFilter ){  FacetFiltersForm.updateURLHash(searchParams, _currentTag); }else{  FacetFiltersForm.updateURLHash(searchParams); }}
  }

  static renderSectionFromFetch(url, event) {
    // console.log('renderSectionFromFetch url', url);
    
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        //btn for filter drawer apply now in mobile
        let applyNow = document.querySelector("[data-apply-now]");
        // console.log("applyNow",applyNow);
        let dataDisable = $(html).find("[data-apply-now]").attr("data-disable");
        applyNow.setAttribute("data-disable",dataDisable);
        if(dataDisable == 'true') applyNow.classList.add("disabled");
        // if($(html).find('.mobile-facets__main input[type="checkbox"]:checked').length > 1) applyNow.classList.add("disabled");
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    // console.log('renderSectionFromCache filterDataUrl', filterDataUrl);
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    setTimeout(function(){
      if( typeof pageRenderChkGrid == 'function' ) pageRenderChkGrid();
      if( typeof pageRenderChkGridsale == 'function' ) pageRenderChkGridsale();
      document.querySelector('facet-filters-form').update_attr_url();
      if( window.customJs != undefined ){
        window.customJs.productCardClick();
      }
      cardHover();
      
      if( document.querySelector('[data-sale-btn].active') != null ){
        document.getElementById('ProductGridContainer').querySelectorAll('[data-compare-price="false"]:not(.sale-hidden)').forEach(function(ele){
          ele.classList.add('sale-hidden');
        });
      }
      //FacetFiltersForm.pageinfiniteScrolling();      
    },500);
    
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
      if( document.querySelector('.total-pro .productCount') ){
        document.querySelector('.total-pro .productCount').innerHTML = count.indexOf('of') > -1 ? count.split('of')[0].trim() :  count.indexOf('products') > -1 ? count.split('products')[0].trim() :  count;
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    // console.log("facetDetailsElements",facetDetailsElements);
    const matchesIndex = (element) => {      
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;      
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    
    facetsToRender.forEach((element) => {      
      if( document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`) != null ){
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));    
    if( typeof generateSlider == 'function' ){
      generateSlider( $(window).width() > 749 ? '' : 'Mobile-' );
     }
    
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector,index) => {
      const activeFacetsElement = html.querySelector(selector);
      // console.log("activeFacetsElement", activeFacetsElement);
      if(index == 1){
        // console.log("active",activeFacetsElement.querySelectorAll("facet-remove").length);
        let activeLen = activeFacetsElement.querySelectorAll("facet-remove").length;
        if(activeLen <= 1){
          $(".active-facets.active-facets-desktop").addClass("no-filter");
          $(".active-facets.active-facets-mobile").addClass("no-filter");
          collectionGrid.classList.add("no-filter");
        }
        else{
          $(".active-facets.active-facets-desktop").removeClass("no-filter");
          $(".active-facets.active-facets-mobile").removeClass("no-filter");
          collectionGrid.classList.remove("no-filter");
        }
      }
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams, currentTag = []) {  

    //history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    // // console.log("currentTag",currentTag);
    var _coll_url = window.location.pathname;
    // // console.log(currentTag,' Before');
    if( _coll_url.match(/\//g).length > 2){
      _coll_url = _coll_url.split('/');
      _coll_url = _coll_url.filter((a) => a);    
      _coll_url = `/${_coll_url[0]}/${_coll_url[1]}`;
    }    
    // // console.log(currentTag,' After');
    // // console.log('_coll_url',_coll_url,currentTag,searchParams);
    if(searchParams == ''){
      var sort_by = $('#SortBy').val();
      searchParams = 'sort_by='+sort_by;
    }

    if(searchParams.indexOf('&') > -1 && searchParams.indexOf('page=') > -1){
      var _searchParam = searchParams.split('&');
      
      var value = _searchParam.indexOf('page');
      _searchParam = _searchParam.filter(function(item) {
          if(item.indexOf('page') < 0){
            return item;
          }
      })
      _searchParam = _searchParam.join('&');
      searchParams = _searchParam;
    }

    if(searchParams.indexOf('page=') > -1){
      searchParams = '';
    }

    // console.log(searchParams,searchParams.indexOf('?page'))

    
    
    if( currentTag.length > 0 ){      
      history.replaceState({ searchParams }, '', `${_coll_url}/${ currentTag.join('+') }${searchParams && '?'.concat(searchParams)}`);      
    }else{
      /*history.pushState({})*/
      history.replaceState({ searchParams }, '', `${_coll_url}${searchParams && '?'.concat(searchParams)}`);
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  update_attr_url(){
    $('facet-remove').each(function (index, ele) {
      if($(this).hasClass('active-facets__button-wrapper')){
        return;
      }
      var _url = $(ele).find('a').attr('href');
      if($(ele).find('a').attr('data-tag-rT') != undefined){
        if(window.location.search == ''){
          var sort_by = $('#SortBy').val();
          _url = _url +'?sort_by='+sort_by+'&'+$(ele).find('a').attr('data-tag-rT');
        }else{
          _url = _url + '?' + $(ele).find('a').attr('data-tag-rT');
        }
        
        // console.log('_url asd ', _url);
        $(ele).find('a').attr('href',_url);
        $(ele).find('a').removeAttr('data-tag-rT');
      }
      
    });    
  }

  static pageinfiniteScrolling() {    
    console.log('pageinfiniteScrolling');
    if($('#product-grid[data-infinite-loaded]').length == 1 && $('#product-grid[data-infinite-loading]').length == 0){ 
      return;
    }
    console.log('pageinfiniteScrollingreturn');
    $('#product-grid').attr('data-infinite-loading','');
    // console.log('pageinfiniteScrolling');
    if($('#ProductGridContainer[data-infinite-scroll="true"]').length == 0){ 
      return; 
    }   
    console.log('pageinfiniteScrollingreturn end');
    
    // var _method = 'click';

    // //for template collection == new
    // if($(".new-collection-grid").length){
    //   _method = 'scroll';
    // }

    // console.log(window.endlessScroll);
    // if(typeof window.endlessScroll != 'undefined'){
    //   window.endlessScroll.destroy();  
    // }

    
    // window.endlessScroll = new Ajaxinate({
    //   container: '#product-grid',
    //   pagination: '#AjaxinatePagination',
    //   offset : 3000,
    //   method: _method
    // });

    // console.log(window.endlessScroll);
    
    $('#product-grid').removeAttr('data-infinite-loading','');
    $('#product-grid').attr('data-infinite-loaded','');
    return true;
    console.log('pageinfiniteScrollinglast');
  }


  onSubmitHandler(event) {
    event.preventDefault();
      const formData = new FormData(event.target.closest('form'));
      const searchParams = new URLSearchParams(formData).toString();
      FacetFiltersForm.renderPage(searchParams, event);    
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    
    // console.log('url', event.currentTarget);
    // console.log('url', url,event.currentTarget);
    // console.log('url',url);
    
    FacetFiltersForm.renderPage(url, event); 
    if(event.currentTarget.classList.contains("remove-all") == true){      
      $(".filters-mens-womens input").prop("checked",false);
      $(".active-facets.active-facets-mobile").addClass("no-filter");
      $(".active-facets.active-facets-desktop").addClass("no-filter");
      //$('.mobile-facets__details.active summary').trigger('click');
      // document.querySelector(".mobile-facets__details.active").setAttribute('open','');
      // document.querySelector(".mobile-facets__details.active .mobile-facets__submenu").style.disaply = 'none';
      // document.querySelector(".mobile-facets__details.active").classList.remove("active");
      //$('#Details-Mobile-SortyBy .facets__list .list-menu__item[data-value='+$('#Details-Mobile-SortyBy .facets__list').attr('data-default-sortby')+']').trigger('click');
      $('#Details-Mobile-SortyBy .facets__list .list-menu__item.selected, #Facet-Desk-SortyBy .list-menu__item.selected').removeClass('selected');      
      var _mobiSortSelected = $('#Details-Mobile-SortyBy .facets__list .list-menu__item[data-value='+$('#Details-Mobile-SortyBy .facets__list').attr('data-default-sortby')+']');
      _mobiSortSelected.addClass('selected');
      // console.log("add class selected");
      $('#Details-Mobile-SortyBy .facets__summary>div span').text($(_mobiSortSelected).find('label').text());
      var _deskSortSelected = $('#Details-Desk-SortyBy .facets__list .list-menu__item[data-value='+$('#Details-Desk-SortyBy .facets__list').attr('data-default-sortby')+']')
      $(_deskSortSelected).addClass('selected');
      $('#Details-Desk-SortyBy .facets__summary>div span').text($(_deskSortSelected).find('label').text());
      if( $(window).width() < 750 & $('.mobile-facets__disclosure.disclosure-has-popup.menu-opening').length > 0 ){
        $('.mobile-facets__disclosure.disclosure-has-popup.menu-opening summary .mobile-facets__close').trigger('click');
      }
      store_tag[1].check_tag = [];
      localStorage.setItem("FilterObj", JSON.stringify(store_tag));
    }    
    
    // console.log("$(.filters-mens-womens input)",$(".filters-mens-womens input"));
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {    
    this.adjustToValidValues(event.currentTarget || event.target);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
      const list = JSON.parse(localStorage.getItem("FilterObj"))[1].check_tag;
      const curr_color = this.querySelector('a').getAttribute('data-tag') || '';
      if(curr_color.indexOf('colorgroup_') > -1){
        const index = list.indexOf(curr_color);
        if (index > -1) { 
          list.splice(index, 1); 
        }
        store_tag[1].check_tag = list;
        localStorage.setItem("FilterObj", JSON.stringify(store_tag));
      }      
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class infiniteCardLoading extends HTMLElement {
  constructor() {
    super();
    
    if(!this.querySelector('[data-loading-type]')) return;
    
    this.loadingType = this.querySelector('[data-loading-type]').dataset.loadingType;
    this.url = this.querySelector('[data-loading-type]').getAttribute('href');
    
    if(this.loadingType == 'click'){
      this.querySelector('[data-loading-type]').addEventListener('click', this.onPaginationChange.bind(this));
    }else{
      this.callbackForViewPort();
    }
  }

  callbackForViewPort(){
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.onPaginationChange();
    };
    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 300px 0px' }).observe(this);
  }

  onPaginationChange(event){
    if(event) event.preventDefault();
    //this.querySelector('.loading-overlay__spinner').classList.remove('hidden'); // button loader
    this.querySelector('.pagination__item').innerHTML = 'Loading';
    // const url = this.url.split('?')[1];
    const url = this.url.split('?')[1];
    this.renderNewPage(url, null);
  }

  renderNewPage(searchParams, event) {
    var currtag_get = document.querySelector('#product-grid').getAttribute('data-curr');
    var curr_url = (window.location.pathname);
    var curr_tag = [];
    
    if(curr_url.match(/\//g).length > 2){
      var temp_split = curr_url.split('/')[(curr_url.split('/').length) - 1];
      if(temp_split.indexOf('+') > -1){
        temp_split = temp_split.split('+');
        for(var j=0;j<temp_split.length;j++){
          curr_tag.push(temp_split[j]);
        }
      }else{
        curr_tag.push(temp_split);
      }
    }
    
    const sections = FacetFiltersForm.getSections();
    //document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      //console.log('url >>',url)
      this.renderSection(url, event);
    });

    FacetFiltersForm.updateURLHash(searchParams, curr_tag);
  }

  renderSection(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        this.renderProductGrid(html);
        FacetFiltersForm.renderProductCount(html);
        document.querySelector('facet-filters-form').update_attr_url();
        if (typeof pageRenderChkGrid === 'function') pageRenderChkGrid();
        if (typeof cardHoverNew === 'function') cardHoverNew();
      });
  }
  
  renderProductGrid(html) {
    const productCard = document.querySelector('#ProductGridContainer #product-grid');
    const pagination = document.querySelector('#ProductGridContainer .pagination-wrapper');
    const DOM = new DOMParser().parseFromString(html, 'text/html');
    
    productCard.innerHTML += DOM.querySelector('#ProductGridContainer #product-grid').innerHTML;
    pagination.innerHTML = DOM.querySelector('#ProductGridContainer .pagination-wrapper').innerHTML;

    if( document.querySelector('[data-sale-btn].active') != null ){
      productCard.querySelectorAll('[data-compare-price="false"]:not(.sale-hidden)').forEach(function(ele){
        ele.classList.add('sale-hidden');
      });
    }

  }

}

customElements.define('ajaxinate-loading', infiniteCardLoading);


if(activeFacetDesk.classList.contains('no-filter') == true){
}else{
  collectionGrid.classList.remove("no-filter");
}
